export function removeMarks(text) {
    return text.replace(/\(\d+\)/g, '');
}
export default function processText(text) {
    return text.replace('\n', ' <break time="0.3s" /> ');
}
